import 'isomorphic-fetch';

interface FetchServiceConfigProps {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly serviceConfigsServiceConfig?: string
}

export const fetchServiceConfig = async ({ faServicesUrl, apiKey }: FetchServiceConfigProps): Promise<any> => {
  const params = new URLSearchParams();

  params.set('useGlobalConfig', 'true');
  params.set('groupBy', 'name');
  params.set('isInventory', 'true');
  params.set('includeModelYears', 'true');

  const url: string = `${faServicesUrl}/modelsConfig?${params.toString()}`;

  const response = await fetch(url, { headers: { 'x-api-key': apiKey } });

  if (response.status >= 400) {
    throw new Error(`Failed to fetch service config: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data;
}